// extracted by css-extract-rspack-plugin
export default {"cls1":"ArticleToolbar-cls1_mrf","cls2":"ArticleToolbar-cls2_vsX ArticleToolbar-cls1_mrf"};